import React from 'react';
import styled from 'styled-components';

import { WIZARD_CARDS_ELEVATION } from '../../../shared/constants';

import { DEQ_COMPS } from '../../../utils/deq';
import { ReactMarkdownExtended } from '../../../utils/generic';

import mq from '../../../styles/breakpoints';
import { H2, IntroText } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

import { WizardItem } from '../../../types/wizard';
import WizardCard from '../../layouts/wizard-layout/WizardCard';
import { NavigationType } from '../../pages/wizard-page/WizardPage.types';

interface WizardStepProps extends WizardItem {
  navigationType: NavigationType;
  hasIframe?: boolean;
}

const WizardStep = ({
  title,
  items,
  visual,
  navigationType,
  hasIframe = false,
}: WizardStepProps) => (
  <div>
    {title && <StyledTitle>{title}</StyledTitle>}
    {visual?.body && (
      <StyledIntroText>
        <ReactMarkdownExtended componentType={DEQ_COMPS.wizardStep}>
          {visual.body.childMarkdownRemark.rawMarkdownBody}
        </ReactMarkdownExtended>
      </StyledIntroText>
    )}
    <StyledList>
      {items.map((option, index) => (
        <WizardCard
          key={index}
          {...option}
          navigationType={navigationType}
          cardElevation={
            hasIframe ? WIZARD_CARDS_ELEVATION.high : WIZARD_CARDS_ELEVATION.low
          }
        />
      ))}
    </StyledList>
  </div>
);

const StyledList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  & > li {
    margin-bottom: ${Spacings.XS};

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

const StyledTitle = styled(H2)`
  margin-top: 0;
  padding: 0 ${Spacings.S};

  ${mq.from.breakpoint.M`
    padding: 0;
  `}
`;

const StyledIntroText = styled(IntroText)`
  display: block;

  p {
    margin: 0 ${Spacings.S} ${Spacings.S};
  }

  ${mq.from.breakpoint.M`
    p {
      margin: 0 0 ${Spacings.XL} 0;
    }
  `}
`;

export default WizardStep;
